import React, {useEffect} from 'react'
import styled, {css} from 'styled-components'

const AccountPickerContainer = styled.div<{
  $isHidden?: boolean
}>`
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  transition: opacity 0.3s;
  opacity: 1;

  iframe {
    width: 100%;
    height: 100%;
    border-width: 0;
  }

  ${({$isHidden}) =>
    $isHidden &&
    css`
      visibility: hidden;
      opacity: 0;
    `}
`

export interface AccountPickerProps {
  onLoaded?: (accountsIds: string[], workspaceKey: string) => void
  onSubmit?: (accountId: string, accountListIndex: number, workspaceKey: string) => void
  onCancel?: () => void
  onError?: () => void
  isVisible?: boolean
}

const AccountPicker: React.FC<AccountPickerProps> = ({
  onLoaded,
  onSubmit,
  onCancel,
  onError,
  isVisible,
}) => {
  const onReceiveMessage = (message: MessageEvent) => {
    if (message.origin === window.location.origin && !!message.data) {
      try {
        const data = JSON.parse(message.data)

        switch (data.type) {
          case 'account-picker/loaded':
            if (onLoaded) {
              onLoaded(data?.payload?.accountsIds, data?.payload?.workspaceKey)
            }
            break

          case 'account-picker/submit':
            if (onSubmit) {
              onSubmit(
                data?.payload?.accountId,
                data?.payload?.accountsListIndex,
                data?.payload?.workspaceKey,
              )
            }
            break

          case 'account-picker/cancel':
            if (onCancel) {
              onCancel()
            }
            break
          case 'account-picker/error':
            if (onError) {
              onError()
            }
            break
          default:
            //do nothing
            break
        }
      } catch (e) {
        //do nothing
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', onReceiveMessage, true)

    return () => {
      window.removeEventListener('message', onReceiveMessage)
    }
  }, [])

  const accountPickerUrl = `${window.location.origin}/app/account-picker/`

  return (
    <AccountPickerContainer $isHidden={!isVisible}>
      <iframe title="Account picker" src={`${accountPickerUrl}?filterCanCreateBoard=1`} />
    </AccountPickerContainer>
  )
}

export default AccountPicker
